import { CheckoutOrderQuery, OrderLineType } from '@/__generated__/graphql';
import { Card, Stack } from '@mantine/core';
import { DataTable } from 'mantine-datatable';

export const OrderSummary = ({ order }: { order: CheckoutOrderQuery['checkoutOrder'] }) => {
  return (
    <Card withBorder component={Stack} p={0}>
      <DataTable
        highlightOnHover
        records={order.lines ?? []}
        minHeight={150}
        columns={[
          {
            accessor: 'code',
            title: 'Kód',
            footer: `${order.lines?.filter((line) => line.type === OrderLineType.Product).length} ks`,
            render: ({ code, type }) => type === OrderLineType.Product && code,
          },
          {
            accessor: 'name',
            title: 'Názov',
            footer:
              order.lines?.find((line) => line.type === OrderLineType.Shipping) &&
              order.lines.find((line) => line.type === OrderLineType.Payment)
                ? `Spolu (s poštovným):`
                : `Spolu (bez poštovného):`,
            textAlign: 'right',
          },
          {
            accessor: 'price',
            title: 'Cena',
            render: ({ price }) => `${price} €`,
            footer: `${order.total} €`,
            textAlign: 'right',
          },
        ]}
        backgroundColor="transparent"
      />
    </Card>
  );
};
